/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Observable } from "@vienna-hypertext/observable";

import { LogSnapshot, LogType, MessageRole } from "@vienna/common";
export class Log extends Observable<LogSnapshot> {
  private constructor(snapshot: LogSnapshot) {
    super(snapshot);
  }

  public addContent(content: string): void {
    this.setState({ content: this.snapshot.content + content });
  }

  public get name(): { text: string; color: string } {
    switch (this.snapshot.role) {
      case MessageRole.AI:
        return { text: "GPT", color: "#FF9900" };
      case MessageRole.Human:
        return { text: "User", color: "#33FF00" };
      case MessageRole.System:
        return { text: "System", color: "#6100FF" };
      default:
        throw new Error("Invalid log role");
    }
  }

  public get infoLevel(): { text: string; color: string } | null {
    switch (this.snapshot.type) {
      case LogType.Step:
        return { text: LogType.Step, color: "#3e51ff" };
      case LogType.Info:
        return { text: LogType.Info, color: "#C7C6CC" };
      case LogType.Message:
        return null;
      case LogType.Failure:
        return { text: LogType.Failure, color: "#FF0000" };
      case LogType.Success:
        return { text: LogType.Success, color: "#33FF00" };
      case LogType.Action:
        return { text: LogType.Action, color: "#FF3D00" };
      default:
        throw new Error("Invalid log type");
    }
  }

  public static create(role: MessageRole, type: LogType, content: string, id: string): Log {
    const snapshot: LogSnapshot = { role, type, content, id };
    return Log.fromSnapshot(snapshot);
  }

  public static fromSnapshot(snapshot: LogSnapshot): Log {
    return new Log(snapshot);
  }
}
